import { ComponentProps } from 'react';

import { cx } from '@libs/classnames';

import styles from './FancyPanel.module.css';

export type FancyPanelTitleProps = {} & ComponentProps<'h2'>;

export function FancyPanelTitle({ className, ...rest }: FancyPanelTitleProps) {
  return <h2 className={cx(styles.title, className)} {...rest} />;
}
